export const FETCH_CROSSCONNECT_UPLINK_TELEMETRY = 'FETCH_CROSSCONNECT_UPLINK_TELEMETRY';

export const FETCH_CROSSCONNECT_UPLINK_TELEMETRY_IS_PENDING = 'FETCH_CROSSCONNECT_UPLINK_TELEMETRY_IS_PENDING';

export const FETCH_CROSSCONNECT_UPLINK_TELEMETRY_IS_ERROR = 'FETCH_CROSSCONNECT_UPLINK_TELEMETRY_IS_ERROR';
